// extracted by mini-css-extract-plugin
export var active = "_i5-7";
export var blink = "_i5-8";
export var dropDownSelector = "_i5-4";
export var dropDownWrapper = "_i5-3";
export var fakeCursor = "_i5-6";
export var fontSizeButton = "_i5-9";
export var formQuillEditor = "_i5-0";
export var pressed = "_i5-a";
export var qlBlank = "_i5-1";
export var textFormattingToolbar = "_i5-2";
export var textToolbarOption = "_i5-5";